import { Button, Modal } from 'antd'
import { ModalProp } from '../../types'
import { useNavigate } from 'react-router-dom'

const ModalSuccess = ({ isModalOpen, closeModal }: ModalProp) => {
  const navigate = useNavigate()
  const handleOk = () => {
    closeModal()
    navigate('/')
  }
  return (
    <Modal
      className='modal bg-[#0C1C33]'
      title={
        <div className='text-[#00D4FF] text-xl font-bold'>ポイントチャージ</div>
      }
      centered
      open={isModalOpen}
      onCancel={handleOk}
      footer={[
        <Button key='back2' type='primary' onClick={handleOk}>
          閉じる
        </Button>
      ]}
    >
      <p className='text-lg'>お支払いが完了しました</p>
    </Modal>
  )
}

export default ModalSuccess
